'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _components = require('../../components');

var _TspDisclaimer = require('./TspDisclaimer.css');

var _TspDisclaimer2 = _interopRequireDefault(_TspDisclaimer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TspDisclaimer = (_dec = (0, _reactCssModules2.default)(_TspDisclaimer2.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(TspDisclaimer, _Component);

  function TspDisclaimer(props) {
    (0, _classCallCheck3.default)(this, TspDisclaimer);
    return (0, _possibleConstructorReturn3.default)(this, (TspDisclaimer.__proto__ || (0, _getPrototypeOf2.default)(TspDisclaimer)).call(this, props));
  }
  //


  (0, _createClass3.default)(TspDisclaimer, [{
    key: 'getIndex',
    value: function getIndex(fund_id) {
      return {
        'FTSP00000C': ['S&P 500 Index', 'iShares Core S&P 500 ETF', 'IVV', 'FSUSA00B4O', 'FEUSA0000E'],
        'FTSP00000I': ['MSCI EAFE Index', 'iShares MSCI EAFE ETF', 'EFA', 'FSUSA00B7C', 'FEUSA0002W'],
        'FTSP00000S': ['Dow Jones U.S. Completion Total Stock Market Index', 'Fidelity® Extended Market Index Fund', 'FSMAX', 'FSUSA003EG', 'F00000MJRH']
      }[fund_id] || [];
    }
    //

  }, {
    key: 'getShareclassUrl',
    value: function getShareclassUrl(indexConfig) {
      var safeTicker = indexConfig[2] || 'N';

      var A = '' + _config2.default.domain;
      var B = _config2.default.routes.fund + '/';
      var C = _format2.default.sanitize(indexConfig[1]) + '/';
      var D = safeTicker + '/';
      var E = _config2.default.profilePath + '/';
      var F = indexConfig[3] + '/';
      var G = indexConfig[4] + '/';

      return '' + A + B + C + D + E + F + G;
    }
    //

  }, {
    key: 'render',
    value: function render() {
      if (!this.props.shareclass) {
        return null;
      }
      //
      var index = this.getIndex(this.props.shareclass.fund_id);
      var indexName = null;
      var indexFundName = null;
      var indexFundTicker = null;
      var indexUrl = null;

      if (index && index.length > 0) {
        indexName = index[0];
        indexFundName = index[1];
        indexFundTicker = index[2];
        indexUrl = this.getShareclassUrl(index);
      }
      //
      return _react2.default.createElement(
        'div',
        { styleName: 'tsp-disclaimer' },
        _react2.default.createElement(
          'div',
          { styleName: 'tsp-disclaimer-icon' },
          _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: 'fa-info-circle' })
        ),
        _react2.default.createElement(
          'p',
          null,
          'The Thrift Savings Plan funds do not publish full portfolio holdings, but they track indexes that are shared with other mutual funds.',
          indexName ? _react2.default.createElement(
            'span',
            null,
            '\xA0',
            this.props.shareclass.fund_legal_name,
            ' tracks the ',
            indexName,
            '. The results below are based on the holdings of the ',
            _react2.default.createElement(
              _components.Link,
              {
                to: indexUrl,
                title: indexFundName,
                xstrong: true
              },
              _react2.default.createElement(
                'span',
                { styleName: 'tsp-index-link' },
                indexFundName
              )
            ),
            ' (',
            indexFundTicker,
            '), which tracks the same index.'
          ) : _react2.default.createElement(
            'span',
            null,
            '\xA0',
            this.props.shareclass.fund_legal_name,
            ' is a mix of the TSP C, S, I, F, and G funds. We model the L fund portfolios using the allocation details published by the Thrift Savings Plan, and use matching index funds to represent the constituent TSP funds.'
          )
        )
      );
    }
  }]);
  return TspDisclaimer;
}(_react.Component)) || _class);
exports.default = TspDisclaimer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/core/TspDisclaimer/TspDisclaimer.js
// module id = 1396
// module chunks = 0